import MaxWeightPreservedTypography from 'components/utils/MaxWeightPreservedTypography'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import BodyText from '../Typography/BodyText'

const Label = styled(MaxWeightPreservedTypography)`
  transition: color 200ms;
`

interface Props extends PropsWithChildren {
  state: 'active' | 'inactive' | 'completed'
  underline?: boolean
}

function _StepLabel(props: Props) {
  const { children, state, underline } = props

  return <Label
    underline={underline}
    Typography={BodyText}
    variant="medium"
    weight={state !== 'inactive' ? 'bold' : 'normal'}
    colour={state === 'inactive' ? 'neutral-three' : 'neutral-one'}
    wrap="no-wrap"
  >
    {children}
  </Label>
}

export default _StepLabel
